import { PRODUCT_ROUTE_NAME } from '@/libs/route-name';
import type { RouteRecordRaw } from 'vue-router';

export const addProductRoute = (): RouteRecordRaw => ({
  path: '/product/add',
  name: PRODUCT_ROUTE_NAME.ADD_PRODUCT,
  component: () => import('@/pages/product/add-product.vue'),
});

export const editProductRoute = (): RouteRecordRaw => ({
  path: '/product/edit/:id',
  name: PRODUCT_ROUTE_NAME.EDIT_PRODUCT,
  component: () => import('@/pages/product/edit-product.vue'),
});

export const variantManagementRoute = (): RouteRecordRaw => ({
  path: '/product/:id/variants',
  name: 'variant-management',
  component: () => import('@/pages/product/variant-management.vue'),
});
